// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tui-image-editor-container[data-v-14db6cc0] {\n    border: 1px solid #ddd;\n}\n.tui-image-editor-container svg[data-v-14db6cc0] {\n    fill: #fff;\n}\n.tui-image-editor-container[data-v-14db6cc0]{\n    min-height: 700px !important;\n    min-width: 550px !important\n}\n.v-card[data-v-14db6cc0]{\n  min-width: 600px !important;\n  background-color: #fff !important;\n}\n", ""]);
// Exports
module.exports = exports;
